import React from "react";
import CnaeDataTable from "./Cnae/CnaeDataTable";
import Card from "../../components/page/Card";
import useApi from "../../hooks/useApi";
import CnaeApiClient from "../../api/cnae";
import CnaeModal from "./Cnae/CnaeModal";
import Validation from "../../helpers/Validation.js";
import ErrorSwal from "../../components/Swal/errorSwal.jsx";
import CommonSwal from "../../components/Swal/commonSwal";

function Cnae() {
  const [relacionamentos, setRelacionamentos] = React.useState([]);
  const [cnaes, setCnaes] = React.useState([]);
  const [itensServico, setItensServico] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [cnaeModal, setCnaeModal] = React.useState(false);

  const { request: getCnaes, data: cnaesResponse } = useApi(
    CnaeApiClient.listCnaes
  );
  const { request: getItensServico, data: itensServicoResponse } = useApi(
    CnaeApiClient.listItensServico
  );
  const { request: getCnaeRelacionamento, data: cnaeRelacionamentoResponse } =
    useApi(CnaeApiClient.listCnaeRelacionamento);
  const createCnaeRelacionamentoApi = useApi(
    CnaeApiClient.createCnaeRelacionamento
  );
  const destroyCnaeRelacionamentoApi = useApi(
    CnaeApiClient.destroyCnaeRelacionamento
  );

  //Busca cnaes ao renderizar tela
  React.useEffect(() => {
    getCnaes();
  }, [getCnaes]);

  //Busca itens de serviço ao renderizar tela
  React.useEffect(() => {
    getItensServico();
  }, [getItensServico]);

  //Busca relacionamento cnae/atividade ao renderizar tela
  React.useEffect(() => {
    getCnaeRelacionamento();
  }, [getCnaeRelacionamento]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (cnaesResponse) setCnaes(cnaesResponse);
  }, [cnaesResponse]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (itensServicoResponse) setItensServico(itensServicoResponse);
  }, [itensServicoResponse]);

  //Define o retorno da api nos valores das linhas
  React.useEffect(() => {
    if (cnaeRelacionamentoResponse)
      setRelacionamentos(cnaeRelacionamentoResponse);
  }, [cnaeRelacionamentoResponse]);

  const togCnaeModal = () => {
    setValues({});
    setCnaeModal(true);
  };

  const criarRelacionamento = async () => {
    const formData = new FormData();
    formData.append("cnae", values?.cnae);
    formData.append("item_servico", values?.itemServico);
    formData.append("cnae_descricao", values?.cnaeDescricao);
    formData.append("item_descricao", values?.itemDescricao);
    formData.append(
      "fator_r",
      values?.fatorR ? (values?.fatorR === "Não" ? 0 : 1) : ""
    );

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    formData.append(
      "anexos",
      values?.anexo ? JSON.stringify(values?.anexo) : ""
    );

    const response = await createCnaeRelacionamentoApi.request(formData);
    if (!response) return;
    setCnaeModal(false);
    getCnaeRelacionamento();
    CommonSwal({
      icon: "success",
      title: "Relacionamento criado com sucesso!",
    });
  };

  const apagarRelacionamento = async (uid) => {
    const response = await destroyCnaeRelacionamentoApi.request(uid);
    if (!response) return;
    getCnaeRelacionamento();
    CommonSwal({
      icon: "success",
      title: "Relacionamento apagado com sucesso!",
    });
  };

  return (
    <>
      <Card>
        <CnaeDataTable
          linhas={relacionamentos}
          togCnaeModal={togCnaeModal}
          apagarRelacionamento={apagarRelacionamento}
        />
      </Card>
      <CnaeModal
        isOpen={cnaeModal}
        setIsOpen={setCnaeModal}
        valuesHook={{ values, setValues }}
        cnaes={cnaes}
        itensServico={itensServico}
        criarRelacionamento={criarRelacionamento}
      />
    </>
  );
}

export default Cnae;
